import { useMediaQuery, useTheme } from '@mui/material';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import React from 'react';

import { useMenuContainerStyles } from './menuStyles/menuContainerStyles';
import { HeaderMenuLarge } from './shared/HeaderMenuLarge';
import { HeaderMenuSmall } from './shared/HeaderMenuSmall';

export function MenuContainer() {
  const theme = useTheme();
  const styles = useMenuContainerStyles(theme);

  const isSmallOrLess = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className={`header-menu-container ${styles.root}`}>
      <AppBar color="inherit" data-testid="app-bar" position="static" className={styles.appBar}>
        <Toolbar
          disableGutters={true}
          variant="dense"
          className={`header-menu-toolbar ${styles.toolBar}`}
        >
          <Box className={styles.smallMenuContainer}>{isSmallOrLess && <HeaderMenuSmall />}</Box>
          <Box className={styles.largeMenuContainer}>{!isSmallOrLess && <HeaderMenuLarge />}</Box>
        </Toolbar>
      </AppBar>
    </Box>
  );
}
